/**
 * Store Pinia — userInfo
 *
 * Migré depuis `store/modules/userInfo.js`. Infos de l'utilisateur connecté
 * (indépendant du système d'auth msal/oidc). Persisté en localStorage.
 *
 * Équivalences Vuex → Pinia :
 *   - getters.getImageProfil   → getters.getImageProfil
 *   - mutations.updateUser     → actions.updateUser
 *   - mutations.resetUser      → actions.resetUser
 *   - mutations.updateImageProfil → actions.updateImageProfil
 *   - mutations.updateNewCard  → actions.updateNewCard
 *   - mutations.resetNewCard   → actions.resetNewCard
 */
import { defineStore } from 'pinia'

const emptyInfo = () => ({
  name: '',
  firstName: '',
  displayName: '',
  username: '',
  usernameVerification: '',
  email: '',
  roles: [],
})

export const useUserInfoStore = defineStore('userInfo', {
  state: () => ({
    info: emptyInfo(),
    imageProfile: null,
    newCardContratId: null,
  }),

  getters: {
    getImageProfil: (state) => state.imageProfile,
  },

  actions: {
    updateUser (payload) {
      this.info = payload
    },
    resetUser () {
      this.info = emptyInfo()
      this.imageProfile = null
    },
    updateImageProfil (payload) {
      this.imageProfile = payload
    },
    updateNewCard (payload) {
      this.newCardContratId = payload
    },
    resetNewCard () {
      this.newCardContratId = null
    },
  },

  persist: true,
})
